import { NgModule } from '@angular/core';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MarkdownModule } from 'ngx-markdown';
import { SharedModule } from 'src/app/modules/shared.module';
import { MentionComposerModule } from '../mention-composer/mention-composer.module';
import { CopilotLauncherComponent } from '../copilot-launcher/copilot-launcher.component';
import { CopilotSidepanelComponent } from '../copilot-sidepanel/copilot-sidepanel.component';
import { CopilotDecisionSummaryComponent } from '../copilot-decision-summary/copilot-decision-summary.component';
import { CopilotChartComponent } from '../copilot-chart/copilot-chart.component';
import { CopilotTableComponent } from '../copilot-table/copilot-table.component';
import { CopilotTableGridComponent } from '../copilot-table-grid/copilot-table-grid.component';
import { CopilotTableDialogComponent } from '../copilot-table-dialog/copilot-table-dialog.component';
import { CopilotChartDialogComponent } from '../copilot-chart-dialog/copilot-chart-dialog.component';
import { CopilotAnalysisComponent } from '../copilot-analysis/copilot-analysis.component';

const components = [
  CopilotLauncherComponent,
  CopilotSidepanelComponent,
  CopilotDecisionSummaryComponent,
  CopilotChartComponent,
  CopilotTableComponent,
  CopilotTableGridComponent,
  CopilotTableDialogComponent,
  CopilotChartDialogComponent,
  CopilotAnalysisComponent,
];

@NgModule({
  declarations: [...components],
  imports: [
    SharedModule,
    MatTooltipModule,
    MatTableModule,
    MatSortModule,
    MarkdownModule.forChild(),
    MentionComposerModule,
  ],
  exports: [...components],
})
export class CopilotModule {}
